import { render, staticRenderFns } from "./UpdateInstance.vue?vue&type=template&id=2284beaf&"
import script from "./UpdateInstance.vue?vue&type=script&lang=js&"
export * from "./UpdateInstance.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInstance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports